import React from 'react';
import truncateMarkdown from 'lib/truncateMarkdown';
import Markdown from '../Markdown/Markdown';

export default ({ children, truncate = false, ...props }) => (
  <Markdown {...props}>
    {truncate ? truncateMarkdown(children, truncate) : children}
  </Markdown>
);
